import { ICopyColetaPrecoUseCase } from "../../../presentation/useCases/create/copy_coleta_preco_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CopyColetaPrecoUseCase
 */

export class CopyColetaPrecoUseCase implements ICopyColetaPrecoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async copyColetaPreco(
    idColetaPreco: number,
  ): Promise<void> {
    await this.repository.copyColetaPreco(
      idColetaPreco,
    );
  }
}
